import { Minus, Plus } from 'lucide-react';
import { cn } from '@/lib/utils';

// Contador +/- com input numérico. Usado em contagem de amostragem (MIP) e
// qualquer entrada numérica discreta com toque no campo. 0 aparece como vazio
// (placeholder) pra leitura rápida de "nada lançado".
export interface StepperProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  className?: string;
  ariaLabel?: string;
}

export function Stepper({
  value, onChange, min = 0, max = Number.POSITIVE_INFINITY, step = 1, className, ariaLabel,
}: StepperProps) {
  const clamp = (v: number) => Math.min(max, Math.max(min, v));
  const btn = 'size-7 inline-flex items-center justify-center rounded-md border border-border text-text-2 hover:bg-surface2';
  return (
    <div className={cn('inline-flex items-center gap-1', className)}>
      <button type="button" aria-label="diminuir" className={btn} onClick={() => onChange(clamp(value - step))}>
        <Minus size={13} strokeWidth={2} />
      </button>
      <input
        type="number"
        inputMode="decimal"
        aria-label={ariaLabel}
        value={value === 0 ? '' : value}
        placeholder="0"
        onChange={(e) => onChange(clamp(Number(e.target.value) || 0))}
        className="h-7 w-12 rounded-md border border-border2 bg-elevated text-center text-sm text-text focus:border-accent focus:outline-none"
      />
      <button type="button" aria-label="aumentar" className={btn} onClick={() => onChange(clamp(value + step))}>
        <Plus size={13} strokeWidth={2} />
      </button>
    </div>
  );
}
